export const jobs = [
  {
    id: 1,
    title: "Junior Front-end Developer",
    dates: "May 2021 - Present",
    duties: [
      "Took part in the Front end development processes B2B and B2C e-commerce web sites of Avansas and Istikbal",
      "Developed responsive web sites from concept through deployment usingHTML5, SCSS and jQuery",
      "Worked with Ajax to write/read data from back end system",
      "Collaborated with team members using version control systems such as Git to organize modifications",
      "Experienced in working Agile based project methodology",
      "Managed deployment and test process with Jenkins",
      "Bug fixes, problem solutions and Backoffice development",
    ],
    company: "Enoca",
  },
  {
    id: 2,
    title: "System&Network Intern",
    dates: "July 2019 – August 2019",
    duties: [
      "By participating in the Aras Cargo internship program, i have the opportunity to listen to the career advice of valuable mentors and developers and toexperience how the departments work in cooperation while a project is beingdeveloped",
      "Maked database queries using mssql database and reported this datas inExcel",
      "Dealt the needs of developers for system, network, equipment andinstallation issues",
    ],
    company: "Aras Cargo",
  },
  {
    id: 3,
    title: "Software Developer Intern",
    dates: "July 2019 – August 2019",
    duties: [
      "Experienced android applications and object-oriented programming",
      "Learned web development fundamentals",
      "Improved Company's web site using pure HTML,CSS and Javascript",
    ],
    company: "Pars Ar-Ge",
  },
];
